var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferPatientBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 7,
    fill: "#E3E9F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6519 35.7476C62.6507 35.7464 62.6496 35.7453 62.6484 35.7442L42.2524 15.3489C41.383 14.4791 40.2272 14 38.9977 14C37.7682 14 36.6124 14.4787 35.7426 15.3485L15.3573 35.7335C15.3504 35.7403 15.3435 35.7476 15.3367 35.7545C13.5514 37.55 13.5544 40.4633 15.3454 42.2543C16.1637 43.073 17.2444 43.5471 18.3999 43.5967C18.4468 43.6013 18.4941 43.6036 18.5418 43.6036H19.3547V58.6133C19.3547 61.5834 21.7713 64 24.7422 64H32.7218C33.5305 64 34.1866 63.3443 34.1866 62.5352V50.7676C34.1866 49.4122 35.2891 48.3098 36.6444 48.3098H41.351C42.7064 48.3098 43.8088 49.4122 43.8088 50.7676V62.5352C43.8088 63.3443 44.4645 64 45.2736 64H53.2532C56.2241 64 58.6407 61.5834 58.6407 58.6133V43.6036H59.3945C60.6236 43.6036 61.7795 43.1248 62.6496 42.2551C64.4425 40.461 64.4433 37.5428 62.6519 35.7476Z",
    fill: "#17468C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferPatientBack);
export default __webpack_public_path__ + "static/media/refer-patient-back.22e482b0a48f02bfe0c4ac5f239fc0f5.svg";
export { ForwardRef as ReactComponent };